if(!customElements.get('featured-collections')) {
  class FeaturedCollections extends HTMLElement {
    constructor() {
      super();

      this.elTabPanels = this.querySelectorAll('[data-featured-collections-tabpanel]');
      this.elTabList = this.querySelector('[data-featured-collections-tablist]');
      this.elNav = this.querySelectorAll('[data-featured-collections-nav]');

      this.currentSwiper = null;

      this.elTabPanels && this.buildTabs();
      this.elNav.forEach(el => el.addEventListener('click', this.navigateTabs.bind(this)));
      window.addEventListener('resize', this.disableEnableNavigation.bind(this));
    }

    buildTabs() {
      const elTabs = document.createElement('div');
      elTabs.classList.add('featured-collections--tabs');
      elTabs.classList.add('container');
      elTabs.innerHTML = `
        <div role="tablist" class="featured-collections--tabs-inner scrollbar--none">
          ${[...this.elTabPanels].map((elPanel, index) => `
            <button
              role="tab"
              id="${elPanel.getAttribute('aria-labelledby')}"
              aria-controls="${elPanel.id}"
              aria-selected="${index == 0}"
              tabindex="${index == 0 ? 0 : -1}"
              class="featured-collections--tab "
              data-featured-collection-tab
            >
              ${elPanel.dataset.heading}
            </button>
          `).join('')}
        </div>
      `

      this.elTabList.prepend(elTabs);
      this.bindTabs();
    }

    bindTabs() {
      this.focusIndex = 0;
      this.elTabs = this.querySelectorAll('[data-featured-collection-tab]');

      this.elTabs.forEach(el => el.addEventListener('click', this.setActiveTab.bind(this)));
      this.elTabs[this.focusIndex] && this.elTabs[this.focusIndex].dispatchEvent(new Event('click'));
    }

    navigateTabs({ currentTarget }) {
      const isNext = currentTarget.getAttribute('data-featured-collections-nav') == 'next';
      const newTabIndex = isNext ? this.focusIndex + 1 : this.focusIndex - 1;
      const actualTabIndex = newTabIndex > this.elTabs.length - 1 ? 0 : newTabIndex < 0 ? this.elTabs.length - 1 : newTabIndex;

      const changeTab = () => {
        this.currentSwiper.slideTo(0)
        this.elTabs[actualTabIndex] && this.elTabs[actualTabIndex].dispatchEvent(new Event('click'));
        this.focusIndex = actualTabIndex;
      }

      const changeSlide = () => {
        isNext ? this.currentSwiper.slideNext() : this.currentSwiper.slidePrev();
      }

      if(this.currentSwiper) {
        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        const shouldChangeTab = isNext ? this.currentSwiper.isEnd || !this.currentSwiper.allowSlideNext : this.currentSwiper.isBeginning || !this.currentSwiper.allowSlidePrev;
        isDesktop ? shouldChangeTab ? changeTab() : changeSlide() : changeSlide();
      } else {
        changeTab();
      }
    }

    disableEnableNavigation() {
      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      this.elNav.forEach(el => el.disabled = isDesktop ? false : this.currentSwiper.isBeginning && this.currentSwiper.isEnd);
    }

    setActiveTab({ currentTarget }) {
      const elTab = currentTarget;
      const activePanel = elTab.getAttribute('aria-controls');

      this.classList.add('loading');

      this.elTabPanels.forEach(el => {
        const isActive = el.id == activePanel;
        el.toggleAttribute('hidden', !isActive);
        el.tabIndex = isActive ? 0 : -1;

        if(isActive) {
          this.currentSwiper = el.querySelector('[data-featured-collection-carousel]').swiper;
          this.disableEnableNavigation();
        }
      });

      this.elTabs.forEach((el, index) => {
        const isActive = el == elTab;
        el.classList.toggle('active', isActive); 
        el.setAttribute('aria-selected', isActive);
        isActive && el.focus({ preventScroll: true });
        this.focusIndex = index - 1; 
      });

      setTimeout(() => this.classList.remove('loading'), 300);
    }
  }

  customElements.define('featured-collections', FeaturedCollections);
}